import { gql } from "graphql-request";
export const POST_BY_ID = gql`
    query PostById($id: Int) {
        post(id: $id) {
            excerpt
            title
            body
            categoryId
            languages
            createdAt
            updatedAt
            publishedAt
            related {
                title
                url {
                    isMain
                    main {
                        url
                    }
                    url
                }
            }
            translations {
                key
                value
                language
            }
            image {
                id
                path
                fullPath
                caption
            }
            tags {
                id
                name
                slug
                isPublished
            }
            urls {
                isMain
                language
                main {
                    url
                }
                url
            }
            url {
                isMain
                language
                main {
                    url
                }
                url
            }
            metatags {
                key
                value
            }
            writerUser {
                id
                name
                nickname
                nicknameSlug
                bio
                position
            }
            editorUser {
                id
                name
                nickname
                nicknameSlug
                bio
                position
            }
        }
    }
`;
